import { render, staticRenderFns } from "./CogWhite.vue?vue&type=template&id=0271f4ae&scoped=true&"
var script = {}
import style0 from "./CogWhite.vue?vue&type=style&index=0&id=0271f4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271f4ae",
  null
  
)

export default component.exports